import styled, { css } from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const FieldsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const FieldItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const FieldLabel = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 16.8px;
    color: ${theme.v2.colors.neutral.lowDark};
  `}
`;

export const FieldWrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
 
    span {
      font-size: ${theme.v2.font.sizes.xs};
      font-weight: ${theme.v2.font.weights.regular};
      color: ${theme.v2.colors.neutral.lowMedium};
    }
  `}
`;

export const PasswordWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const TerminalWrapper = styled.div`
  width: 100%;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const ModalDescription = styled.p`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    color: ${theme.v2.colors.neutral.lowDark};
    margin: 0;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }

    a {
      font-size: inherit;
    }
  `}
`;

export const ModalButtonWrapper = styled.div`
  width: 100%;
`;
